import React, { useEffect, useState } from "react";
import MilesPointsTaskCard from "./MilesPointsTaskCard";
import { useMilesPoints } from "../../../hooks/useMilesPoints";

function MilesPointsDashboardTasks() {
  const { getMilesPointsTasks } = useMilesPoints();
  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    await getMilesPointsTasks({ setLoading });
  };

  useEffect(() => {
    loadData();
  }, []);
  const tasks = [
    {
      title: "Make 30 Total Bookings",
      description:
        "Reach a total of 30 bookings (any combination of flight, hotel, or tour).",
      points: "1,500pts",
      done: 14,
      total: 30,
      type: "gold",
    },
    {
      title: "Book a Hotel",
      description: "Successfully complete 1 hotel booking.",
      points: "50pts",
      done: 0,
      total: 1,
      type: "silver",
    },
    {
      title: "Complete Profile",
      description: "Fill in agency details, upload logo, and set contact info.",
      points: "20pts",
      done: 5,
      total: 5,
      type: "bronze",
    },
    {
      title: "Book a Flight",
      description: "Successfully complete 1 flight booking through the system.",
      points: "50pts",
      done: 0,
      total: 1,
      type: "silver",
    },
  ];
  return (
    <div className="w-full flex flex-col pt-4 pb-6 gap-3 px-6 bg-white">
      {tasks.map((task, index) => (
        <MilesPointsTaskCard task={task} key={index} />
      ))}
    </div>
  );
}

export default MilesPointsDashboardTasks;
